import { getPalette, sampleGradient } from '@wg/shared';

const STOPS = [0, 0.25, 0.5, 0.75, 1] as const;

export function applyPalette(paletteId: string, el: HTMLElement = document.documentElement): void {
  const palette = getPalette(paletteId);
  if (!palette) throw new Error(`Unknown palette: ${paletteId}`);
  for (const stop of STOPS) {
    const [r, g, b] = sampleGradient(palette, stop);
    const key = `--palette-${Math.round(stop * 100)}`;
    el.style.setProperty(key, `${r} ${g} ${b}`);
  }
}
